// extracted by mini-css-extract-plugin
module.exports = {"CheckBox":"CheckBox_CheckBox__2ahNa","Checkmark":"CheckBox_Checkmark__38QHg","Error":"CheckBox_Error__MSxAo","ErrorItem":"CheckBox_ErrorItem__1ioep"};